package net.gorillagroove.user

import com.squareup.sqldelight.ColumnAdapter
import kotlinx.serialization.Serializable
import net.gorillagroove.util.GGLog.logError
import kotlin.jvm.JvmInline

@Serializable
enum class UserVisibilityType {
    NORMAL,
    HIDDEN,
    BLOCKED,
    UNKNOWN,
    ;

    fun toRawType() = RawUserVisibilityType(this.name)
}

@Serializable
@JvmInline
value class RawUserVisibilityType(val value: String) {
    fun asEnumeratedType(): UserVisibilityType {
        return try {
            UserVisibilityType.valueOf(value)
        } catch (e: Throwable) {
            this.logError("Unknown enumerated type value '$value' for enum '${UserVisibilityType::class.simpleName}'")
            UserVisibilityType.UNKNOWN
        }
    }
}

object RawUserVisibilityTypeAdapter : ColumnAdapter<RawUserVisibilityType, String> {
    override fun decode(databaseValue: String) = RawUserVisibilityType(databaseValue)
    override fun encode(value: RawUserVisibilityType) = value.value
}
